import React from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty, find, cloneDeep, set, filter } from 'lodash';
import classnames from 'classnames';
import ModalManager from '../../elements-modal/modal-manager';
import { DeclineUpdateModal } from '../decline-update-modal';
import ReviewSpaceRentalTable from '../../elements-tables/review-space-rental-table';
import TextButton from '../../elements-buttons/text-button';
import { CTAButton } from 'shared-components/buttons/cta-button';
import AddOnsTable from '../../app-main/components/reduxForms/fieldSets/AddOnsTable/add-ons-table';
import PayoutDifferenceTable from '../../elements-tables/PayoutDifferenceTable';
import { acceptGuestUpdate } from '../../app-main/actions/contracts';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { normalizedContractsShape } from '../../app-bookings-request/forms/bookingUtil';
import { BookingSummary } from '../../elements-summaries/booking-summary/BookingSummary';

class ReviewGuestUpdateHV extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.declineUpdate = this.declineUpdate.bind(this);
    this.acceptUpdate = this.acceptUpdate.bind(this);

    this.state = {
      errorText: '',
      isLoading: false
    };
  }

  declineUpdate() {
    const { toggleModal } = this.props;
    toggleModal('declineUpdateModal');
  }

  acceptUpdate() {
    const {
      dispatch,
      controlId,
      accessToken,
      iosWebView,
      closeIOSModal,
      finalCb
    } = this.props;

    this.setState({
      isLoading: true
    });

    dispatch(
      acceptGuestUpdate(controlId, accessToken, (response) => {
        if (200 === response.statusCode) {
          if (iosWebView) {
            closeIOSModal();
            return finalCb();
          }
          return this.context.router.push({ pathname: `/inbox/${controlId}` });
        }

        this.setState({
          isLoading: false,
          errorText: this.props.intl.formatMessage({
            id: 'inbox_review_booking_update.review_guest_update_HV.something_wrong',
            defaultMessage: 'Something went wrong, please try again.'
          })
        });
      })
    );
  }

  render() {
    const { errorText } = this.state;
    const {
      hostId,
      guestId,
      currency,
      booking,
      accessToken,
      closeIOSModal,
      finalCb,
      pendingContracts,
      currentContracts,
      iosWebView,
      toggleModal,
      whichModal,
      profile,
      intl
    } = this.props;

    const guestName = get(this.props, 'booking.guest.name.first', '');
    const isCleaningFee = !!find(booking.addtl_charges, {
      type: 'CLEANING_FEE'
    });
    const cleaningFee = isCleaningFee
      ? get(booking, 'addtl_charges[0].charge_amount', '')
      : null;
    const discounts = get(booking, 'discounts', []);
    const masterCalc = get(pendingContracts, 'masterContract.calculations', {});
    const spaceRentalSubtotal = get(
      pendingContracts,
      'spaceRentalContract.amount.000000000000000000000000',
      0
    );
    const addOnsTotal = get(
      pendingContracts,
      'masterContract.calculations.add_ons.amount',
      0
    );
    const hostAddOnsSummary = get(masterCalc, 'host_add_ons_summary', {});

    const hostAddOns = filter(get(pendingContracts, 'items', []), (addOn) => {
      return !addOn.meta.is_concierge;
    });

    const displayAddOnsTotal =
      get(masterCalc, 'host_add_ons_summary') ||
      (addOnsTotal && isEmpty(get(masterCalc, 'concierge_add_ons_summary')));

    const activityDetailBooking = cloneDeep(booking);
    if (!isEmpty(activityDetailBooking)) {
      activityDetailBooking.payment = {};
      activityDetailBooking.list_price = {};
      activityDetailBooking.payout = {};
      activityDetailBooking.view_as = 'HOST';
      activityDetailBooking.listing = get(
        pendingContracts,
        'spaceRentalContract.meta.listing',
        {}
      );
      activityDetailBooking.customOfferStep = 'review';
      activityDetailBooking.attendees = booking.number_of_guests;
      set(activityDetailBooking, 'guest.sso_id', get(booking, 'guest.ssoid'));
      delete activityDetailBooking.host;
    }

    return (
      <div
        className='ReviewBookingUpdateMain ps-row'
        data-testing-id='review-booking-container-host-view'
      >
        <div className='margin-md-top col-xs-12'>
          <TextButton
            id='back-to-message-button'
            buttonText={this.props.intl.formatMessage({
              id: 'inbox_review_booking_update.review_guest_update_HV.message',
              defaultMessage: 'Message'
            })}
            icon={<div className='custom-arrow left' />}
            iconPosition='left'
            classNames='margin-md-top'
            onClick={closeIOSModal || this.context.router.goBack}
          />
        </div>
        <div
          className={classnames('flex space-between middle header col-xs-12', {
            iosWebView
          })}
        >
          <h3>
            <FormattedMessage
              id='inbox_review_booking_update.review_guest_update_HV.booking_update'
              defaultMessage='Booking Update'
            />
          </h3>
        </div>

        <div className='col-md-8'>
          <ModalManager whichModal={whichModal} toggleModal={toggleModal}>
            <DeclineUpdateModal
              {...this.props}
              ref='declineUpdateModal'
              accessToken={accessToken}
              bookingID={booking._id}
              guestName={guestName}
              closeIOSModal={closeIOSModal}
              finalCb={finalCb}
              viewAs='HOST'
            />
          </ModalManager>

          <ReviewSpaceRentalTable
            cleaningFee={cleaningFee}
            subtotal={booking.subtotal_amount}
            total={spaceRentalSubtotal}
            currency={currency}
            discounts={discounts}
            masterContract={pendingContracts?.masterContract}
          />

          {!isEmpty(hostAddOns) && (
            <AddOnsTable
              isReviewPage
              addOnsTotal={addOnsTotal}
              itemsArray={pendingContracts.items}
              contract={pendingContracts.spaceRentalContract}
              masterContract={pendingContracts.masterContract}
              ssoId={hostId}
              currency={currency}
              hostAddOnsSummary={hostAddOnsSummary}
            />
          )}

          <PayoutDifferenceTable
            currentContracts={currentContracts}
            pendingContracts={pendingContracts}
            discounts={booking.discounts}
            displayAddOnsTotal={displayAddOnsTotal}
            hostId={hostId}
            guestId={guestId}
            currency={currency}
            tableHeaders={[
              {
                label: this.props.intl.formatMessage({
                  id: 'inbox_review_booking_update.review_guest_update_HV.payout',
                  defaultMessage: 'Payout'
                }),
                style: { width: '50%' }
              },
              {
                label: this.props.intl.formatMessage({
                  id: 'inbox_review_booking_update.review_guest_update_HV.previous',
                  defaultMessage: 'Previous'
                }),
                classname: 'text-right d-xs-none d-sm-block',
                style: { width: '25%' }
              },
              {
                label: this.props.intl.formatMessage({
                  id: 'inbox_review_booking_update.review_guest_update_HV.new',
                  defaultMessage: 'New'
                }),
                classname: 'text-right',
                style: { width: '25%' }
              }
            ]}
            rowClass='row'
          />

          <div className='help-block text-danger text-right'>{errorText}</div>

          <div className='cta-buttons flex space-between margin-xl-top'>
            <CTAButton
              onClickAction={this.declineUpdate}
              buttonText={this.props.intl.formatMessage({
                id: 'inbox_review_booking_update.review_guest_update_HV.decline',
                defaultMessage: 'Decline'
              })}
              classNameString='btn btn-gray-outline'
              isDisabled={false}
            />
            <CTAButton
              onClickAction={this.acceptUpdate}
              buttonText={this.props.intl.formatMessage({
                id: 'inbox_review_booking_update.review_guest_update_HV.accept_update',
                defaultMessage: 'Accept Update'
              })}
              classNameString='btn btn-primary margin-lg-left'
              isDisabled={false}
              spinning={this.state.isLoading}
            />
          </div>
        </div>
        <div
          className='activity-details col-md-4'
          data-testing-id='summary-container'
        >
          <BookingSummary
            booking={activityDetailBooking}
            profile={profile}
            intl={intl}
          />
        </div>
      </div>
    );
  }
}

ReviewGuestUpdateHV.propTypes = {
  dispatch: PropTypes.func,
  booking: PropTypes.object,
  accessToken: PropTypes.string,
  SSOid: PropTypes.string,
  closeIOSModal: PropTypes.func,
  finalCb: PropTypes.func,
  controlId: PropTypes.string,
  hostId: PropTypes.string,
  guestId: PropTypes.string,
  currency: PropTypes.string,
  pendingContracts: normalizedContractsShape,
  currentContracts: normalizedContractsShape,
  iosWebView: PropTypes.bool,
  toggleModal: PropTypes.func,
  whichModal: PropTypes.string,
  intl: intlShape
};

ReviewGuestUpdateHV.contextTypes = {
  router: PropTypes.object
};

exports.ReviewGuestUpdateHV = injectIntl(ReviewGuestUpdateHV);
